import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const s=i("zcash",t`
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            static
            fill="none"
        >
            <path
                d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                fill="black"
            />
            <path
                d="M11.9997 21.3382C17.1572 21.3382 21.3382 17.1572 21.3382 11.9997C21.3382 6.84213 17.1572 2.66113 11.9997 2.66113C6.84213 2.66113 2.66113 6.84213 2.66113 11.9997C2.66113 17.1572 6.84213 21.3382 11.9997 21.3382Z"
                fill="url(#paint0_linear_4874_521)"
            />
            <path
                d="M7.50342 15.7216L10.7626 11.2018C11.3556 10.4267 11.8225 9.86636 12.4108 9.16597V9.11928H7.86295V6.30371H16.3237V8.43289L13.2139 12.766C12.6443 13.5177 12.112 14.2415 11.5237 14.8718V14.9185H16.4964V17.7527H7.50342V15.7216Z"
                fill="black"
            />
            <path
                d="M10.6646 4.2168H13.2467V6.7382H10.6646V4.2168ZM10.6646 17.2627H13.2467V19.7841H10.6646V17.2627Z"
                fill="black"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_4874_521"
                    x1="18.603"
                    y1="5.39634"
                    x2="5.39634"
                    y2="18.603"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#FFD25C" />
                    <stop offset="1" stop-color="#CD8421" />
                </linearGradient>
            </defs>
        </svg>
    `);export{s as ZCash};
